var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCookie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#262926"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.638 8.158c-.219-.166-.501-.222-.769-.155-.257.067-.47.097-.67.097-1.489 0-2.7-1.211-2.703-2.643l.015-.153a.9.9 0 0 0-.336-.737.89.89 0 0 0-.793-.168c-.264.069-.481.102-.684.102C10.211 4.5 9 3.289 9 1.8a2.62 2.62 0 0 1 .089-.644.9.9 0 0 0-.193-.805.9.9 0 0 0-.768-.308A8.96 8.96 0 0 0 0 9c0 4.963 4.037 9 9 9s9-4.037 9-9c0-.044-.003-.087-.006-.144-.006-.274-.137-.532-.355-.698zM9 16.2A7.21 7.21 0 0 1 1.8 9c0-3.351 2.258-6.178 5.405-6.975C7.323 4.403 9.294 6.3 11.7 6.3l.091-.001c.414 2.034 2.204 3.574 4.353 3.6C15.7 13.447 12.666 16.2 9 16.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.45,
    cy: 8.55,
    r: 1.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.85,
    cy: 5.85,
    r: 1.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.95,
    cy: 9.45,
    r: 1.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.15,
    cy: 12.15,
    r: 1.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.65,
    cy: 13.05,
    r: 1.35
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCookie);
export default __webpack_public_path__ + "static/media/cookie.da9629c7006f6f2a07d9a1ef0a8e04cc.svg";
export { ForwardRef as ReactComponent };